import startCase from 'lodash/startCase'

const progressStages = [
  ['Created', 2],
  ['Ready', 2],
  ['Counterparty', 2],
  ['Negotiation', 2],
  ['Signature', 2]
]
const stageOrder = progressStages.map(([name]) => name.toLowerCase())

function finaliseStages(stages) {
  const totalWidth = stages.reduce((acc, [_name, width]) => acc + width, 0)

  return stages.reduce(
    (acc, [name, width], index) =>
      acc.concat({
        name: name,
        width: width / totalWidth,
        Name: startCase(name),
        order: index
      }),
    []
  )
}

export const getCurrentStage = (doc) => {
  const stageLCase = doc.stage.toLowerCase()
  const index = stageOrder.findIndex((stage) => stage === stageLCase) || 0
  return [stageLCase, index]
}

export const getDocProgressStages = () => finaliseStages(progressStages)
